import styled from "styled-components";

export const DetailsPanelDiv = styled.div`
  margin: auto;
  width: 95%;
  height: 100%;
  padding: 10px;
  min-width: 600px;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
`;

export const DetailsPanelLeftSection = styled.div`
  width: 20%;
  height: 100%;
  padding: 3px;
  min-width: 300px;
`;

export const DetailsPanelMiddleSection = styled.div`
  width: 40%;
  height: 100%;
  padding: 3px;
`;

export const DetailsPanelRightSection = styled.div`
  width: 40%;
  height: 100%;
  padding: 3px;
`;

export const SectionForDetailPanelLeftHeader = styled.div`
  float: left;
  width: 50%;
  text-align: right;
`;

export const SectionForDetailPanelLeft = styled.div`
  float: left;
  width: 50%;
`;

export const SectionForDetailPanelRight = styled.div`
  float: left;
  width: 50%;
`;
